module.exports = __webpack_public_path__ + "static/media/floating_icon.ca5df9f2.svg";